import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useSetPlayerTags = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.ISetPlayerTagsRequestData): Promise<Types.ISetPlayerTagsResponseData> => {
        const { data } = await send<Types.ISetPlayerTagsRequestData, Types.ISetPlayerTagsResponseData>({
            ID: 35544,
            description: 'Set player tags',
            responses: [35545, 35546],
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
